import React from 'react';
import { useParams } from 'react-router-dom';
import UserInvitation from '../components/users/UserInvitation';

const UserInvitationPage = () => {
  const { companySlug } = useParams();

  return (
    <div className="user-invitation">
      <div className="user-invitation__content cts-container">
        <UserInvitation />
      </div>
    </div>
  );
};

export default UserInvitationPage;